const UserPermissionsObject = (receiveEmail = false) => {
	const userCheckoutPermissions = [
		{
			category: 'MARKETING',
			code: 'EMAIL',
			state: receiveEmail ? 'GRANTED' : 'DENIED',
		},
		{
			category: 'MARKETING',
			code: 'MAIL',
			state: 'GRANTED',
		},
		{
			category: 'MARKETING',
			code: 'PHONE',
			state: 'GRANTED',
		},
		{
			category: 'MARKETING',
			code: 'SHAREEMAIL',
			state: 'DENIED',
		},
		{
			category: 'MARKETING',
			code: 'SHAREDATA',
			state: 'DENIED',
		},
	];

	return userCheckoutPermissions;
};

export default UserPermissionsObject;
